export const API_BASE = 'https://api.izzywhiteeventing.co.uk/api'; //|| 'https://localhost:5249/api';
export const BS_BASE = `${API_BASE}/BookingSystem`;